<template>
  <div class="user_box--stat">
    <b-tooltip
      :active="label.length !== 0"
      :label="label"
      position="is-top"
      type="is-dark"
    >
      <icon-default :icon="icon" size="is-small" :color="color" alignment="bottom"/>
      <span class="user_box--stat--count">{{ number }}</span>
    </b-tooltip>
  </div>
</template>

<script>
export default {
  name: "StatsTeamUsersStat",
  props: {
    label: {
      type: String,
      default: ''
    },
    number: {
      type: Number,
      required: true
    },
    icon: String,
    color: String
  },
}
</script>

<style scoped lang="scss">
.user_box {
  &--stat {
    margin-right: 17px;

    &:last-child {
      margin-right: 0;
    }
  }
  &--stat--count {
    margin-left: 2px;
    font-size: 15px;
    font-weight: bold;
  }
}
</style>
